import { render, staticRenderFns } from "./Branch.vue?vue&type=template&id=0f1ee5d9&scoped=true"
import script from "./Branch.vue?vue&type=script&lang=ts"
export * from "./Branch.vue?vue&type=script&lang=ts"
import style0 from "./Branch.vue?vue&type=style&index=0&id=0f1ee5d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1ee5d9",
  null
  
)

export default component.exports